import * as actions from 'actions/search';

export const defaultState = {
  results: {},
  loading: false,
  error: false,
};

export default function searchReducer(state = defaultState, action) {
  switch (action.type) {
    case actions.SEARCH:
      return {
        ...state,
        loading: true,
      };
    case actions.SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actions.SEARCH_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
